import { render } from "./CompletedColonoscopyOverlay.vue?vue&type=template&id=9fc43604&lang=pug"
import script from "./CompletedColonoscopyOverlay.vue?vue&type=script&lang=js"
export * from "./CompletedColonoscopyOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__